import packageJSON from '../../../package.json'
import * as Updates from 'expo-updates'
import { Platform } from 'react-native'

import { getBuildNumber } from './appVersion'

const STAGE = process.env.EXPO_PUBLIC_STAGE
const BUILD_COMMIT_HASH = process.env.EXPO_PUBLIC_BUILD_COMMIT_HASH || ''

// Web has no binary, so the commit hash stands in for a build number.
const buildNumber = Platform.OS === 'web' ? (BUILD_COMMIT_HASH?.slice(0, 7) ?? '') : getBuildNumber()
const expoUpdateId = Updates.updateId?.slice(-4) ?? ''

export const BUILD_VERSION_FORMATTED_TEXT = `${STAGE} v${packageJSON.version}  ${buildNumber} ${expoUpdateId}`
